import React from 'react';
import { Navigate } from 'react-router-dom';
import { getDefaultRouteForRole } from '../utils/roleUtils';

const RoleLanding = ({ session, fallback: FallbackComponent, ...props }) => {
  const target = getDefaultRouteForRole(session);
  if (target && target !== '/') {
    return <Navigate to={target} replace />;
  }
  if (!FallbackComponent) return null;
  return <FallbackComponent session={session} {...props} />;
};

export default RoleLanding;
